module.exports = __webpack_public_path__ + "static/11-081dfc2402c40a05d307de0d1259148a.png";